import React from 'react';

import tmsTrackActivityShape from '../../../../../shapes/tms-track-activity';
import ActivityWrapper from '../activity-wrapper';
import { ACTIVITY_TYPES } from '../../../../../constants';
import NoteSection from '../note-section';
import { formatUsername } from '../../../../../utils/common';

/**
 * TMS Track Event activity
 * @param {object} params - Object containing props for this component
 * @param {object} params.activity - Activity object to show
 * @return {element} - Tms Track Event Component
 */
const ActivityTmsTrack = ({ activity }) => {
  const initiatorInfo = { text: `${formatUsername(activity.initiatorName)} added a Tracking Update in TMS` };
  const locationInfo = { text: 'Driver Location', descriptor: `${activity.city}, ${activity.state}` };

  let headerContent = [initiatorInfo];
  if (activity.city && activity.state) {
    headerContent = [initiatorInfo, locationInfo];
  }

  return (
    <ActivityWrapper
      type={ACTIVITY_TYPES.internalTmsNote}
      headerContent={headerContent}
      timestamp={activity.eventTime}
      testId="activity-tms-track"
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityTmsTrack.propTypes = {
  activity: tmsTrackActivityShape.isRequired,
};

export default ActivityTmsTrack;
